import { render, staticRenderFns } from "./CreateRule.vue?vue&type=template&id=0e8015bd&"
import script from "./CreateRule.vue?vue&type=script&lang=js&"
export * from "./CreateRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports